import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { FlagEditComponent } from './flag-edit/flag-edit.component';
import { FlagListComponent } from './flag-list/flag-list.component';

@NgModule({
  declarations:
    [
      FlagEditComponent,
      FlagListComponent
    ],
  imports:
    [
      SharedModule
    ],
  exports:
    [
      FlagEditComponent,
      FlagListComponent
    ]
})
export class FlagModule { }
